var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg-white p-8 lg:p-16",staticStyle:{"border-radius":".5rem"}},[_c('h2',[_vm._v(" Not Found!")])])])}]

export { render, staticRenderFns }